<script>
    import { onMount } from 'svelte';
    import Icon from 'fa-svelte'
    import { faBackward } from '@fortawesome/free-solid-svg-icons/faBackward';
     
    let icon = faBackward;
    let data = [];
    let parms = [];
    let fixes = [];
    let warn = false;
    export let params ={};
      
    onMount(async () => {
         const res = await fetch(`https://www.bowls-league.com/mobile/fixtures${params.id}.json`);
         data = await res.json();
         parms = data.p;
         fixes = data.f;
         fixes.forEach (function (fix) {
            if (fix.pnl =="pnl") {
                 warn = true;
                 console.log(visible);
                }
            });
        });
        
</script>

<style>
.container {
    display:grid;
    grid-template-columns:50% 12.5% 10% 17.5% 10%;
    }

.hdr {
    background:tan
}

.item {
    border:1px solid rgba(0, 0, 0, 0.8);
    padding:2px;
    text-align:left
}

.itm {
    border:1px solid #000000cc;
    padding:2px;
    text-align:right
}

.pnl {
       border:1px solid #000000cc;
       padding:2px;
       text-align:right;
       background:#ffff66
   }

.spnl {
       width: 300px;
       padding:5px;
       background:#ffff66
   }

h2,h3 {
    text-align: center;
    margin: 0 0 0 0;
    line-height: 1.5;
    padding: 2px;
    background-color: mistyrose;
}
button {
	border: none;
	border-radius: 12px;
    color: white;
    background-color :#a2a4ab;
	padding: 10px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 16px;
	margin: 6px 4px;
	}
	
</style>

  <section>
   <h2>Peterborough Bowls League</h2>
   <h3>{parms[0]} {parms[1]} -- {parms[2]}</h3>
   <div class="container">
       <div class="item hdr">&nbsp;Against</div><div class="itm hdr">Date&nbsp;</div>
       <div class="itm hdr">Grn&nbsp;</div><div class="itm hdr">Result&nbsp;</div>
       <div class="itm hdr">Pts&nbsp;&nbsp;</div>
       {#each fixes as fix }
          <div class="item">{fix.n}</div>
          <div class="itm">{fix.p}</div>
          <div class="itm">{fix.g}&nbsp;</div>
          <div class="itm">{fix.d[1]}:{fix.d[2]}</div>
          <div class="{fix.pnl}">{fix.d[0]}</div>
       {/each}
   </div>
   </section>
   <footer>
     {#if warn}<div class="spnl">Points adjusted with penalty deductions</div>{/if}
     <button on:click={() => history.back()}> <Icon icon={icon}></Icon>&nbsp;Back</button>
   </footer>